import axios from 'axios'

const elasticsearchClient = axios.create({
  baseURL: process.env.REACT_APP_ELASTICSEARCH_URL // Replace with your Elasticsearch base URL
})

// Add a request interceptor
elasticsearchClient.interceptors.request.use(
  (config) => {
    const username = process.env.REACT_APP_ELASTICSEARCH_USERNAME
    const password = process.env.REACT_APP_ELASTICSEARCH_PASSWORD

    if (username && password) {
      config.auth = {
        username,
        password
      }
    }

    return config
  },
  (error) => {
    // Handle request error
    return Promise.reject(error)
  }
)

// Optionally, add a response interceptor
elasticsearchClient.interceptors.response.use(
  (response) => {
    // Handle response data
    return response
  },
  (error) => {
    // Handle response error
    console.error('Elasticsearch request error:', error)
    return Promise.reject(error)
  }
)

export default elasticsearchClient
